import React from 'react';

import Field, { hasDataInFields } from '../../containers/PageBuilder/Field';
import SectionContainer from '../../containers/PageBuilder/SectionBuilder/SectionContainer';

import { parseNotes, absaetze } from '../contentBits';
import { fixAbsatz, istWegzulassen } from '../textFixes';
import gem from '../salesPage.module.css';
import css from './SectionNotes.module.css';

/**
 * FairwayBid: Regeln und Hinweise als Karten statt als Textwand.
 *
 * Die Abschnitte "Was es kostet" und "Gut zu wissen" enthalten Regeln, die
 * jemand vor der Anmeldung wissen will. Als durchlaufender Text mit
 * Fettschrift liest sie niemand. Zerlegt in Karten liest man wenigstens die
 * Überschriften – und findet die eine Regel wieder, die man sucht.
 *
 * Der Inhalt bleibt in der Console.
 */
const SectionNotes = props => {
  const {
    sectionId,
    className,
    rootClassName,
    title,
    description,
    appearance,
    callToAction,
    blocks = [],
    options,
  } = props;

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };
  const hasHeaderFields = hasDataInFields([title, callToAction], fieldOptions);

  // Die Beschreibung des Abschnitts ist der Einstieg, die Blöcke sind die
  // Karten. Enthält ein Block mehrere fette Überschriften, wird jede zu
  // einer eigenen Karte.
  // Richtigstellung: siehe src/fairwaybid/textFixes.js. Greift nur, solange
  // der widersprüchliche Absatz in der Console steht.
  const einstieg = absaetze(description?.content)
    .filter(a => !istWegzulassen(a, sectionId))
    .map(a => fixAbsatz(a, sectionId));
  const karten = blocks.flatMap(b => parseNotes(b?.text?.content, b?.title?.content));

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <header className={gem.header}>
          <Field data={title} className={gem.headTitle} options={fieldOptions} />
          <span className={gem.rule} aria-hidden="true" />
          <Field data={callToAction} options={fieldOptions} />
        </header>
      ) : null}

      <div className={gem.wrap}>
        {einstieg.length > 0 ? (
          <div className={css.lead}>
            {einstieg.map(a => (
              <p key={a.slice(0, 40)} className={css.leadText}>
                {a}
              </p>
            ))}
          </div>
        ) : null}

        {karten.length > 0 ? (
          <div className={css.notes}>
            {karten.map(k => (
              <article key={(k.headline || '') + k.text.slice(0, 30)} className={css.note}>
                {k.headline ? <h3 className={css.noteHeadline}>{k.headline}</h3> : null}
                {absaetze(k.text).map(a => (
                  <p key={a.slice(0, 40)} className={css.noteText}>
                    {a}
                  </p>
                ))}
              </article>
            ))}
          </div>
        ) : null}
      </div>
    </SectionContainer>
  );
};

export default SectionNotes;
